import { useEffect, useState } from 'react';
import { countdownText, tickerMessages } from '../campaign';

export default function Ticker({ S }) {
  const [cd, setCd] = useState(() => countdownText(S));
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    setCd(countdownText(S));
    const t = setInterval(() => setCd(countdownText(S)), 1000);
    return () => clearInterval(t);
  }, [S]);

  useEffect(() => {
    const onVis = () => setPaused(document.hidden);
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  const [label, val, hot] = cd;
  const msgs = tickerMessages(S);
  const seq = [];
  msgs.forEach((m, i) => { if (i % 2 === 0) seq.push(null); seq.push(m); });

  const items = (dup) => seq.map((x, i) =>
    x === null ? (
      <span key={dup + '-cd-' + i} className={'gfg-tick-item' + (hot ? ' gfg-hot' : '')}>
        <span className="gfg-sep" /><span>{label}</span>&nbsp;<b>{val}</b>
      </span>
    ) : (
      <span key={dup + '-' + i} className="gfg-tick-item"><span className="gfg-sep" />{x}</span>
    ));

  return (
    <div className={'gfg-ticker' + (paused ? ' gfg-paused' : '')}>
      <div className="gfg-tick-track">{items('a')}{items('b')}</div>
    </div>
  );
}
